import ApplicationController from '../application_controller'

export default class extends ApplicationController {
  connect () {
    this.update()
  }

  update () {
    const first = this.element.firstElementChild
    const last = this.element.lastElementChild
    if (!first || !last || first === last) return

    const isWrapped = last.offsetTop > first.offsetTop
    last.classList.toggle('ms-auto', !isWrapped)
  }
}
